import React, { PureComponent } from 'react';
import { dispatch } from '@ro-store';
import { connect } from 'react-redux';

import { getCurrentLegend } from '@ro-utils/common/radar-params';

import { Container, ColorsContainer, LegendWrapper, Item } from './Legend.styles';

class Legend extends PureComponent {
  componentWillReceiveProps(nextProps) {
    const oldLegendTime = this.props.date.valueOf();
    const legendTime = nextProps.date.valueOf();
    if (this.props.mapType !== nextProps.mapType || oldLegendTime !== legendTime) {
      dispatch.ro.setLegendProperties(getCurrentLegend(nextProps.mapType, legendTime));
    }
  }
  componentDidMount() {
    const legendTime = this.props.date.valueOf();
    dispatch.ro.setLegendProperties(getCurrentLegend(this.props.mapType, legendTime));
  }
  render() {
    const { legendProps, legendColors } = this.props;

    return (
      <Container>
        {legendColors && <ColorsContainer scale={legendColors} />}
        <LegendWrapper>
          {legendProps &&
            legendProps.names.map(function(item, i) {
              return <Item key={`${i}_legend`}><span>{parseFloat(item.toFixed(2))}</span></Item>;
            })}
        </LegendWrapper>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  const props = {
    ...state.ro.legend,
    mapType: state.ro.mapType,
    date: state.ro.date
  };
  return props;
};

export default connect(mapStateToProps)(Legend);
